<template>
  <div class="row">
    <div class="col-md-12">
      <div class="card">
        <div class="card-body">
          <b-tabs v-model="tab">
            <b-tab :title="type == 'student' ? 'المقارئ الخاصة بي' :'مقارئ الطلاب'" active>
              <data-table :editItem="editItem" :type="type"></data-table>
            </b-tab>
            <!-- <b-tab @click="newItem = {}" :title="$t('site.add')">
              <my-form :newItem="newItem"></my-form>
            </b-tab> -->
          </b-tabs>
        </div>
        <!-- end of card body --> 
      </div>
      <!-- end of card -->
    </div>
    <!-- end of col -->
  </div>
</template>

<script>
import Auth from "@/Apis/Auth";
import DataTableVue from "./components-v2/DataTable.vue";

export default {
  name: "quranProgramsIndex",
  computed: {
    type(){
      return Auth.USER.account_type;
    }
  },
  components: {
    "data-table": DataTableVue,
  },
  data() {
    return {
      tab: 0,
    };
  },
  
};
</script>

